// extracted by mini-css-extract-plugin
export default {"container":"Header_container__e6i9s","banner":"Header_banner__6cw3m","bannerContent":"Header_bannerContent__v-wTU"};